
export class UpdateFinanceIndividual 
{
    individualId: number|undefined;
    salaireEmprunteur: number;
    salaireConjoint: number;
    montantLoyer: number;
    montantAutreRevenu: number;
    
    totalEngagementActuel: number;
    chargeEmpruntSollicite: number;
    montantBonusDat: number;
    primeTrimestrielle: number;
    domiciliationSalaire: boolean;
    packageSouscrit: String;
    clientEngage: boolean;
    typeCreditSouscrit: String;
    montantCreditSolicite: number;
    echeanceMensuelleCreditSolicite: number;
}